var map = {
	"./Bild10.JPG": 9800,
	"./Bild11.JPG": 5500,
	"./Bild13.JPG": 1648,
	"./Bild15.JPG": 5395,
	"./Bild16.JPG": 1485,
	"./Bild18.JPG": 9399,
	"./Bild20.JPG": 886,
	"./Bild22.JPG": 7615,
	"./Bild24.JPG": 4554,
	"./Bild25.JPG": 9691,
	"./Bild26.JPG": 6848,
	"./Bild3.JPG": 3467,
	"./Bild4.JPG": 5849,
	"./Bild5.JPG": 8235,
	"./Bild6.JPG": 8976,
	"./Bild7.JPG": 3782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7497;